import { Box } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

import type { ColumnAlignTypes } from '../../types'

const FLEX_ALIGNMENT: Record<ColumnAlignTypes, string> = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end'
}

export const Container = styled(Box)<{ align?: ColumnAlignTypes }>`
  ${({ align }) => css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 2px;
    align-items: ${FLEX_ALIGNMENT[align ?? 'left']};
  `}
`

/* O wrapper da célula (`S.TableCellValue`) tem `overflow: hidden`, mas o `text-overflow` dele não
   alcança filhos aninhados — sem isso um rótulo maior que a coluna seria cortado no meio da letra. */
const truncate = css`
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const Label = styled(Box)`
  ${({ theme }) => css`
    font-size: 12px;
    font-weight: 400;
    line-height: 120%;
    color: ${theme.colors.gray[400]};
    ${truncate}
  `}
`

export const Value = styled(Box)<{ isNegative?: boolean }>`
  ${({ theme, isNegative }) => css`
    font-size: 16px;
    font-weight: 700;
    line-height: 120%;
    color: ${isNegative ? theme.colors.error.color : theme.colors.secondary};
    ${truncate}
  `}
`
